import { FC } from 'react'
import { Box, styled, BoxProps } from '@mui/material'
import ClientLogo from 'components/ClientLogo'
import CredentialsForm, { Props as CredentialsFormProps } from 'components/Form/Credentials'
import { useTranslation } from 'react-i18next'

const Wrapper = styled(Box)({
  minHeight: '100vh',
  display: 'flex',
  alignItems: 'center',
  flexDirection: 'column',
})

type Props = Omit<BoxProps, 'onSubmit' | 'onChange'> & CredentialsFormProps

const Login: FC<Props> = ({ onSubmit, onChange, sso, serverError, title, children, rememberMe, ...rest }) => {
  const { t } = useTranslation()
  return (
    <Wrapper py={5} {...rest}>
      <Box display="flex" flexDirection="column" alignItems="center">
        <Box width="20em" height="10em" display="flex" alignItems="end">
          <ClientLogo width="20em" />
        </Box>
        <Box alignSelf="flex-start" pt={3} color="white" fontSize="1.5em" textAlign="left" mb={4}>
          {!title ? t('routes.login.title') : title}
        </Box>
        <CredentialsForm
          onSubmit={onSubmit}
          onChange={onChange}
          serverError={serverError}
          rememberMe={rememberMe}
          sso={sso}
        />
        {children}
      </Box>
    </Wrapper>
  )
}

export default Login
